import { Message } from '../types';
import { Box } from '@mui/material';
import { container } from './styles';
import useStore from '~/store';

interface Props {
  content?: Message['content'];
  author?: Message['author'];
  questionComponent?: Message['questionComponent'];
  Component?: Message['Component'];
}

export const EquipmentConditions = (_props: Props) => {
  const { quote: _quote } = useStore((store) => ({
    quote: store.quote
  }));

  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setEquipmentConditions(Number(event.target.value));
  // };

  //const [error, setError] = useState(false);

  return (
    <Box sx={container}>
      {/* <Box sx={() => containerMessage()}>
        <FormControl>
          <RadioGroup
            aria-labelledby="radio-button-equipment-conditions"
            value={equipmentCondition}
            onChange={handleChange}
          >
            {CONDITIONS.map(({ value, label }) => (
              <FormControlLabel
                key={value}
                value={value}
                label={label}
                control={
                  <Radio inputProps={{ 'aria-label': label }} checkedIcon={<CheckCircleIcon color="success" />} />
                }
              />
            ))}
          </RadioGroup>
        </FormControl>
        <Box sx={messageAfter} />
      </Box> */}
    </Box>
  );
};
